// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import grid01Icon from "@/assets/icons/grid-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Grid01IconProps = Omit<IconProps, "name">;

export function Grid01Icon(props: Grid01IconProps): React.ReactNode {
  return <Icon name={grid01Icon} {...props} />;
}
